import Loader from '@components/framework/loader/Loader';
import React from 'react';

const ButtonLoader = (colorCode?: any): React.ReactElement => {
  return (
    <div>
      <Loader
        style={{color: colorCode || 'white'}}
        color={'secondary'}
        size={16}
      />
    </div>
  );
};
export default ButtonLoader;
